import { TextSmall } from '@/components/Texts';
import React from 'react';

const definitionsList = [
  {
    name: 'Personal data',
    desc: '(Art. 4 No. 1 GDPR) means any information relating to an identified or identifiable natural person ("data subject"). A person is identifiable if he or she can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, an online identifier, location data or by means of information relating to his or her physical, physiological, genetic, mental, economic, cultural or social identity characteristics. The identifiability can also be given by means of a linkage of such information or other additional knowledge. The origin, form or embodiment of the information is irrelevant (photographs, video or audio recordings may also contain personal data).',
  },
  {
    name: 'Processing',
    desc: '(Art. 4 No. 2 GDPR) means any operation which involves the handling of personal data, whether or not by automated (i.e. technology-based) means. This includes, in particular, the collection (i.e. acquisition), recording, organization, arrangement, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment, combination, restriction, erasure or destruction of personal data, as well as the change of a purpose or intended use on which a data processing was originally based.',
  },
  {
    name: 'Controller',
    desc: '( Art. 4 No. 7 DS-GVO) means the natural or legal person, public authority, agency or other body which alone or jointly with others determines the purposes and means of the processing of personal data.',
  },
  {
    name: 'Third Party',
    desc: '( Art. 4 No. 10 DS-GVO) means any natural or legal person, public authority, agency or other body other than the data subject, the controller, the processor and the persons who are authorized to process the personal data under the direct responsibility of the controller or processor; this also includes other group-affiliated legal entities.',
  },
  {
    name: 'A processor',
    desc: `(Art. 4 No. 8 DS-GVO) is a natural or legal person, authority, institution or other body that processes personal data on behalf of the controller, in particular in accordance with the controller's instructions (e.g. IT service provider). In terms of data protection law, a processor is in particular not a third party.`,
  },
  {
    name: 'Consent',
    desc: '( Art. 4 No. 11 GDPR) of the data subject means any freely given, specific, informed and unambiguous indication of his or her wishes in the form of a statement or other unambiguous affirmative act by which the data subject signifies his or her agreement to the processing of personal data relating to him or her.',
  },
];

const Definitions = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(1) Definitions</TextSmall>
      <TextSmall>
        Following the example of Art. 4 of the GDPR, this privacy notice is
        based on the following definitions:
      </TextSmall>
      {definitionsList.map((item, index) => {
        return (
          <React.Fragment key={item.name}>
            <TextSmall pl={8}>
              {' '}
              <TextSmall as='span' fontWeight={'semibold'}>
                {' '}
                - &quot;{item.name} &quot;{' '}
              </TextSmall>{' '}
              {item.desc}
            </TextSmall>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Definitions;
